import Button from 'components/UI/V3/Button/Button';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { FunctionComponent } from 'react';
import styles from './ConfirmCompleteAllModal.module.scss';

interface ConfirmCompleteAllModalProps {
    title: string;
    question: string;
    labelYes?: string;
    onDiscard?: () => void;
    onSave?: () => void;
}

export const ConfirmCompleteAllModal: FunctionComponent<ConfirmCompleteAllModalProps> = props => {
    return (
        <GenericModal
            className={styles.modal}
            footer={
                <div className={styles.footer}>
                    <div className={styles.left}>
                        <Button
                            className={styles.button}
                            label="No"
                            variant="black"
                            onClick={props.onDiscard}
                        />
                    </div>
                    <div className={styles.right}>
                        <Button
                            className={styles.button}
                            label={props.labelYes ?? 'Yes, complete all'}
                            variant="green"
                            onClick={props.onSave}
                        />
                    </div>
                </div>
            }
            onClose={props.onDiscard}
        >
            <div className={styles.title}>{props.title}</div>
            <div className={styles.question}>{props.question}</div>
        </GenericModal>
    );
};

export default ConfirmCompleteAllModal;
